import React from 'react';

// Renders a locked legal document from its authoritative content module.
//
// Structure is semantic rather than styled-to-look-right: one h1 for the
// document title, an h2 per numbered section, real <ul>/<li> for lists, so the
// document can be navigated by heading and its lists announced with counts.
// Every string comes from the generated content module, so nothing here can
// rephrase, reorder or renumber the text.

const EMAIL = /([A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,})/;

// The address stays exactly as written; it is only made tappable, because a
// phone reader cannot practically transcribe it by hand.
const withEmailLinks = (text) =>
  text.split(EMAIL).map((part, index) =>
    part.includes('@') && EMAIL.test(part) ? (
      <a key={`${part}-${index}`} className="legal-link" href={`mailto:${part}`}>
        {part}
      </a>
    ) : (
      part
    )
  );

const Block = ({ block }) => {
  if (block.type === 'list') {
    return (
      <ul className="legal-list">
        {block.items.map((item) => (
          <li key={item}>{withEmailLinks(item)}</li>
        ))}
      </ul>
    );
  }
  if (block.type === 'lines') {
    // One paragraph in the original, broken over several lines.
    return (
      <p className="legal-paragraph">
        {block.lines.map((line, index) => (
          <React.Fragment key={line}>
            {index > 0 && <br />}
            {withEmailLinks(line)}
          </React.Fragment>
        ))}
      </p>
    );
  }
  return <p className="legal-paragraph">{withEmailLinks(block.text)}</p>;
};

export const LegalDocument = ({ doc, testId }) => (
  <article className="legal-doc" data-testid={testId}>
    <h1 className="legal-title">{doc.title}</h1>
    <p className="legal-effective" data-testid={`${testId}-effective-date`}>
      {doc.effectiveDate}
    </p>
    {doc.sections.map((section, sectionIndex) => (
      <section className="legal-section" key={section.heading}>
        <h2 className="legal-heading" data-testid={`${testId}-heading-${sectionIndex + 1}`}>
          {section.heading}
        </h2>
        {section.blocks.map((block, blockIndex) => (
          <Block block={block} key={`${sectionIndex}-${blockIndex}`} />
        ))}
      </section>
    ))}
  </article>
);
